export default {"src":"/_next/static/media/desktop-inverted.cfbd0aef.svg","height":100,"width":284,"blurWidth":0,"blurHeight":0};